import { Alert, Button, Collapse, CollapseProps, DatePicker, Tabs, Typography } from "antd"
import TabPane from "antd/lib/tabs/TabPane"
import axios from "axios";
import dayjs, { Dayjs } from "dayjs";
import React from "react"

export function ExportsGeneral() {
    const [date, setDate] = React.useState<Dayjs>(dayjs());
    const [alertData, setAlertData] = React.useState<{message: string, type: 'success' | 'error'} | null>(null);
    const [isLoading, setIsLoading] = React.useState<boolean>(false);

    const items: CollapseProps['items'] = [
        { //Export Quéguiner
            key: '1',
            label: 'Export mensuel creation Quéguiner',
            children: CollapseItem({
                contentDescription: "Export d'un fichier csv contentant toutes les colonnes de toutes les nouvelles entreprises (celles que l'on a dans nos bases) créées durant le mois sélectionné.",
                contentButtonLabel: 'Export Quéguiner',
                date: date,
                setDate: setDate,
                datePicker: { display: true, pickerType: "month" },
                onClickButton: async () => {
                    setIsLoading(true);
                    const listDepartements = ["14", "22", "29", "35", "44", "49", "50", "53", "56", "61", "85"]
                    const listApe = ["16.23Z", "29.20Z", "31.01Z", "31.02Z", "31.09B", "33.20A", "33.20B", "36.00Z", "37.00Z", "41.20A", "41.20B", "42.11Z", "42.13A", "42.21Z", "42.22Z", "42.99Z", "43.12A", "43.12B", "43.21A", "43.21B", "43.22A", "43.22B", "43.29A", "43.29B", "43.31Z", "43.32A", "43.32B", "43.32C", "43.33Z", "43.39Z", "43.91A", "43.91B", "43.99A", "43.99C", "43.99D", "71.11Z", "74.10Z", "74.90A", "81.30Z", "82.30Z"]
                    try {
                        const response = await axios.get('/exports/exportEntreprisesPerApesAndDeps?departements=' + listDepartements.toString() + '&ape=' + listApe.toString() + (date ? ('&month=' + (date!.month() + 1).toString() + '&year=' + date!.year().toString()) : ''));

                        if(response.status !== 200) {
                            throw new Error("Failed to generate export");
                        }

                        // Trigger file download
                        const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `export_entreprises_queguiner_${date.format('MM_YYYY')}.csv`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        // Show success alert
                        setIsLoading(false);
                        setAlertData({message: "Export généré avec succès.", type: 'success'});
                        setTimeout(() => setAlertData(null), 5000);
                    } catch (error) {
                        console.error("Error during export:", error);
                        setAlertData({message: "Une erreur est survenue lors de la génération de l'export.", type: 'error'});
                        setTimeout(() => setAlertData(null), 5000);
                    } finally {
                        setIsLoading(false);
                    }

                },
                isLoading: isLoading
            })
        }
    ];

    return (
        <Tabs defaultActiveKey="1">
            <TabPane tab="Exports demandes clients" key="1">
                <>
                {alertData &&
                    <Alert message={alertData.message} type={alertData.type} showIcon style={{ marginBottom: 16 }} />
                }
                <Collapse items={items} defaultActiveKey={['1']} />
                </>
            </TabPane>
        </Tabs>
    )
}

interface CollapseItemProps {
    contentDescription: string;
    date: Dayjs;
    setDate: (date: Dayjs) => void;
    datePicker: { display: boolean, pickerType?: "week" | "month" | "quarter" | "year" };
    contentButtonLabel: string;
    onClickButton: () => void;
    isLoading: boolean;
}

function CollapseItem(props: CollapseItemProps) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', padding: '12px 0' }}>
            <Typography.Text>
                {props.contentDescription}
            </Typography.Text>
            <div style={{display: 'flex', flexDirection: 'row', gap: 20}}>
                {props.datePicker.display &&
                    <DatePicker 
                        value={props.date} 
                        onChange={(date) => {
                            props.setDate(date)
                        }}
                        picker={props.datePicker.pickerType}
                        style={{ width: 'fit-content' }} 
                    />
                }
                <Button
                    type="primary"
                    onClick={props.onClickButton}
                    style={{ width: 'fit-content' }}
                    loading={props.isLoading}
                >
                    {props.contentButtonLabel}
                </Button>
            </div>
        </div>
    )
}